module.exports = __webpack_public_path__ + "static/media/ask-beagle.36519f97.svg";